/*!
 * Copyright © 2021-2022. Verizon Connect Ireland Limited. All rights reserved.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatLegacySelectChange } from '@angular/material/legacy-select';
import { EDeviceErrorType, EVehicleStatusType } from '../../../core/models';

@Component({
  selector: 'fm-status-filter-options',
  templateUrl: './status-filter-options.component.html',
  styleUrls: ['./status-filter-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusFilterOptionsComponent implements OnChanges {
  @Input() public statusFilterSelected: EVehicleStatusType;
  @Input() public statusCounts: Map<EVehicleStatusType, number>;

  @Output() public statusFilterChanged: EventEmitter<EVehicleStatusType> = new EventEmitter();

  public showCharging: boolean;

  public EVehicleStatusType = EVehicleStatusType;
  public EDeviceErrorType = EDeviceErrorType;
  private _previousValue: EVehicleStatusType;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.statusCounts) {
      this.showCharging = this.statusCounts.has(EVehicleStatusType.Charging);
    }
  }

  public onStatusFilterChange(value: MatLegacySelectChange) {
    const newValue = value.value as EVehicleStatusType;
    if (newValue !== this._previousValue) {
      this.statusFilterChanged.emit(newValue);
    }
    this._previousValue = newValue;
  }
}
